import React from 'react';
import { Layout, Card, Divider, Row, Col, Space, Typography, Select, DatePicker, Modal, Tooltip } from "antd";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import TickerSearch from "../../modules/Search/TickerSearch/TickerSearch";
import { etfGroupConfig } from "../../configs/tickerConfigs";
import DecompView from "./DecompView/DecompView";
import { SquareRounded } from "@mui/icons-material";
import TickerManager from "./TickerManager";
import { useTickerLauncher } from './useTickerLauncher';
import { fetchPcaModel, fetchCopulaModel } from "../../api/analyticsApi";
import CopulaView from "./CopulaView/CopulaView";
const { RangePicker } = DatePicker;



const MODELS = [
  { value: 'pca', label: 'PCA', action: fetchPcaModel, component: DecompView },
  { value: 'copula', label: 'Copula', action: fetchCopulaModel, component: CopulaView },
];


const ModelView = ({ data }) => {
  const { modelName } = data;
  const ModelComponent = MODELS.find(model => model.value === modelName)?.component;

  return ModelComponent ? (
    <>
      <ModelComponent data={data} />
    </>
  ) : (
    <Typography.Text>Unknown model type: {modelName}</Typography.Text>
  );
};

const IconComponent = ({ Icon }) => <Icon />;

const TickerLauncher = () => {
    const {
        allTickers,
        selectedModel,
        dateRange,
        showGroupModal,
        selectedGroups,
        showSearch,
        showSelectedTickers,
        latestModel,
        status,
        error,
        handleTickerSubmit,
        handleGroupSubmit,
        handleRemoveTicker,
        handleModelChange,
        handleDateRangeChange,
        handleRunModel,
        setShowGroupModal,
        setShowSearch,
        setShowSelectedTickers
    } = useTickerLauncher(MODELS);

    return (
        <Layout>
            <Row gutter={[16, 16]} justify={'space-between'} className={'dropped-shadow'} style={{ padding: '20px 30px' }}>
                <Col>
                    <Space>
                        <Typography.Title level={4}>Models</Typography.Title>
                        <Select
                            style={{ width: 200 }}
                            value={selectedModel}
                            onChange={handleModelChange}
                            options={MODELS}
                        />
                        <RangePicker onChange={handleDateRangeChange} />
                        <Button variant={'contained'} color={'info'} onClick={handleRunModel} disabled={allTickers.length === 0}>
                            Run Model
                        </Button>
                    </Space>
                </Col>
                <Col>
                    <ButtonGroup>

                        <Button onClick={()=>setShowSearch(!showSearch)}>
                            {showSearch ? 'Hide Search' : 'Show Search'}
                        </Button>
                        <Button variant={'contained'} color={'primary'} onClick={() => setShowGroupModal(true)}>Ticker Collections</Button>
                    </ButtonGroup>
                </Col>
            </Row>
            {showSearch && (
                <Row style={{padding: 40}}>
                    <Col flex={'auto'}>
                        <Row wrap={true} align={'top'} justify={'center'} gutter={64}>
                            <Col xs={24} xl={0}>
                                <Row justify={'center'} className={'mb-3'}>
                                    <Button variant={'contained'} onClick={() => setShowSelectedTickers(true)}>
                                        Selected Tickers ({allTickers.length})
                                    </Button>
                                </Row>
                            </Col>
                            <Col xs={24} xl={16}>
                                <TickerSearch onTickersSubmit={handleTickerSubmit} />
                            </Col>
                            {allTickers.length > 0 && (
                                <Col xs={0} xl={8}>
                                    <TickerManager tickers={allTickers} onRemove={handleRemoveTicker} />
                                </Col>
                            )}
                        </Row>
                    </Col>
                </Row>
            )}
            {status === 'loading' && <p>Loading...</p>}
            {status === 'failed' && <p>Error: {error}</p>}
            {status === 'succeeded' && latestModel && (
                <ModelView data={latestModel} />
            )}
            <Modal open={showGroupModal}
                   onOk={() => setShowGroupModal(false)}
                   onCancel={() => setShowGroupModal(false)}
                   width={'90vw'}
                   title={<Typography.Title>Ticker Collections</Typography.Title>}
            >
                <Divider />
                <Alert variant={'outlined'} color={'info'}>
                    Click on the cards below to add the ticker group to your list
                </Alert>
                <Divider />
                <div style={{ maxHeight: '50vh', overflowY: 'scroll' }}>
                    <Row wrap={true} gutter={[32, 32]}>
                        {etfGroupConfig.map((group, index) => (
                            <Col key={group.title} span={6}>
                                <Card title={<Typography.Text>{group.title}</Typography.Text>}
                                      extra={<IconComponent Icon={group.icon} />}
                                      className={'dropped-shadow-hover cursor'}
                                      onClick={() => handleGroupSubmit(group.title, group.symbols.map(x => x.toLowerCase()))}
                                      style={{
                                          background: selectedGroups.includes(group.title) ? 'var(--mint)' : 'var(--white)',
                                      }}
                                >
                                    {group.description}
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </div>
            </Modal>
            <Modal open={showSelectedTickers} onOk={() => setShowSelectedTickers(false)} onCancel={() => setShowSelectedTickers(false)}>
                <TickerManager tickers={allTickers} onRemove={handleRemoveTicker} />
            </Modal>
        </Layout>
    );
};

export default TickerLauncher;